import DynamicFormField from "components/form/DynamicFormField";
import Grid from '@mui/material/Unstable_Grid2';
import { ASSESSMENT_TYPE_CHOICES } from "constants.js";

const Resource = ({ formData, setFormData, handleInputChange }) => {
  const formFields = [
    {
      id: "social_reason",
      label: "Social Reason",
      placeholder: "eg. Boyle and Sons",
      type: "text",
      mdColSpan: 12,
      handleInputChange: handleInputChange,
      value: formData.social_reason
    },
    {
      id: "cnpj",
      label: "CNPJ",
      placeholder: "eg. 71.690.067/0001-43",
      type: "cnpj",
      mdColSpan: 6,
      handleInputChange: handleInputChange,
      value: formData.cnpj
    },
    {
      id: "phone",
      label: "Phone",
      placeholder: "eg. +55 11 99999-9999",
      type: "tel",
      mdColSpan: 6,
      handleInputChange: handleInputChange,
      value: formData.phone
    },
    {
      id: "email",
      label: "Email",
      placeholder: "eg. email@email.com",
      type: "email",
      mdColSpan: 12,
      handleInputChange: handleInputChange,
      value: formData.email
    },
    {
      id: "additional_information",
      label: "Additional Information",
      placeholder: "Additional information about the product",
      type: "textarea",
      handleInputChange: handleInputChange,
      value: formData.additional_information,
      mdColSpan: 12,
      cols: 30, // Set an appropriate number of columns for small screens
      mdCols: 1000, // Set an appropriate number of columns for medium screens
    },
    {
      id: "tax_regime",
      label: "Tax Regime",
      placeholder: "eg. Simples Nacional",
      type: "select",
      mdColSpan: 4,
      options: [
        { value: "Simples Nacional", label: "Simples Nacional" },
        { value: "Lucro Presumido", label: "Lucro Presumido" },
        { value: "Lucro Real", label: "Lucro Real" }
      ],
      handleInputChange: handleInputChange,
      value: formData.tax_regime
    },
    {
      id: "assessment_type",
      label: "Assessment Type",
      placeholder: "Select assessment type",
      type: "select",
      mdColSpan: 4,
      options: ASSESSMENT_TYPE_CHOICES,
      handleInputChange: handleInputChange,
      value: formData.assessment_type
    },
    {
      id: "commercial_agreement",
      label: "Commercial Agreement (%)",
      type: "percentage",
      allowNegative: true,
      mdColSpan: 4,
      handleInputChange: handleInputChange,
      value: formData.commercial_agreement
    },
    {
      id: "markup_rate",
      label: "Markup Rate (%)",
      placeholder: "eg. 1.50",
      type: "percentage",
      mdColSpan: 4,
      handleInputChange: handleInputChange,
      value: formData.markup_rate
    },
    {
      id: "advisory_fee",
      label: "Advisory Fee (R$)",
      type: "number",
      mdColSpan: 4,
      handleInputChange: handleInputChange,
      value: formData.advisory_fee
    },
    {
      id: "advisory_fee_allocation_method",
      label: "Advisory Fee Allocation",
      type: "select",
      mdColSpan: 4,
      options: [
        { value: "POR_PROCESSO", label: "By Process" },
        { value: "POR_CONTAINER", label: "By Container" },
      ],
      handleInputChange: handleInputChange,
      value: formData.advisory_fee_allocation_method
    },
    {
      id: "has_fiscal_benefit_ttd_409",
      label: "Has Fiscal Benefit TTD 409",
      type: "switch",
      mdColSpan: 12,
      handleInputChange: handleInputChange,
      value: formData.has_fiscal_benefit_ttd_409
    },
  ];

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      {/* Header */}
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Client
      </h4>

      {/* content */}
      {/* inputs */}
      <Grid container spacing={2}>
        {formFields.map(field => {
          return (
            <DynamicFormField
              key={field.id}
              field={field}
              formData={formData}
              handleInputChange={handleInputChange}
            />
          );
        })}
      </Grid>
    </div >
  );
};

export default Resource;
